import React from 'react';
import { Button, Person, RecordsTable, Table } from 'dyl-components';

import './index.scss';

const Extensions = ({ extensions, extensionInfo, isLoading, onChangeSip, onResetDevice }) => {
    return (
        <div className='VOIP__extensions-table'>
            <RecordsTable
                isTableLoading={isLoading}
                isTableEmpty={extensions.length === 0}
                hasPagination={false}
                TableHeader={
                    <Table.Row>
                        <Table.HeaderCell>Extension</Table.HeaderCell>
                        <Table.HeaderCell>User Account</Table.HeaderCell>
                        <Table.HeaderCell></Table.HeaderCell>
                    </Table.Row>
                }
                TableRows={!isLoading ? extensions.map(extension => {
                    const isHardphoneAvailable = extensionInfo?.devices?.find(device => device?.extension === extension.extension_number);
                    const isDeviceOrSofPhoneAvailable = isHardphoneAvailable || extensionInfo?.softphones?.find(softphone => softphone?.extension === extension.extension_number)
                    return (
                        <Table.Row key={extension.extension_number}>
                            <Table.Cell>
                                {extension.extension_number}
                            </Table.Cell>
                            <Table.Cell>
                                {extension.user && (
                                    <Person
                                        username={`${extension.user.first_name} ${extension.user.last_name}${extension.user.is_owner ? ` (Owner)` : ''}`}
                                        email={extension.user.email}
                                    />
                                )}
                            </Table.Cell>
                            <Table.Cell textAlign='right'>
                                <Button disabled type="button">Change Extension</Button>
                                <Button onClick={() => { onChangeSip(extension) }} type="button" disabled={!extension.user || !isDeviceOrSofPhoneAvailable}>Change SIP Password</Button>
                                <Button onClick={() => { onResetDevice(extension) }} type="button" disabled={!extension.user || !isHardphoneAvailable}>Hardphone Reset</Button>
                            </Table.Cell>
                        </Table.Row>
                    )
                }) : []}
                recordsCount={0}
                recordsName='Extension'
                noBorder
                emptySubtitleHidden
            />
        </div>
    )
}

export default Extensions;
